import { render, staticRenderFns } from "./Downloading.vue?vue&type=template&id=fdb7a13c"
import script from "./Downloading.vue?vue&type=script&lang=js"
export * from "./Downloading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports